<template>
  <div>
    <My-new-nav ref="header"></My-new-nav>
    <div class="detail">
      <div class="name">{{ data.jobName }}</div>
      <div class="jobAddress">
        <span>{{ data.address ? data.address : "地点不限" }}</span>
        <span class="space">|</span>
        <span>{{ data.recruitNumber ? data.recruitNumber : "人数不限" }}</span>
        <span class="space">|</span>
        <span>{{ data.degree ? data.degree : "学历不限" }}</span>
      </div>
      <div class="title desc"><span class="divide"></span>职位描述</div>
      <div class="introduce">{{ data.duty }}</div>
      <div class="title ask"><span class="divide"></span>任职要求</div>
      <div class="introduce">{{ data.requireInfo }}</div>
      <div class="title ask"><span class="divide"></span>公司信息</div>
      <div class="introduce">简历邮箱：hr@echartnow.com</div>
      <div class="introduce">邮箱简历投递格式：附件名字+应聘岗位+工作地点，例：张三+陕西商务岗位+西安。</div>
      <div class="introduce">集团办公地点：陕西省西安市高新区天谷八路156号西安软件新城研发基地二期C2栋14层1401室。</div>
    </div>
  </div>
</template>

<script>
import { queryPosition } from "../../../../common/api";
import {
  hiddenLoading,
  showLoading,
  showToast,
} from "../../../../common/toast";

export default {
  data() {
    return {
      data: {},
    };
  },
  activated() {
    showLoading();
    const id = this.$route.params.id;
    queryPosition({ id })
      .then((res) => {
        hiddenLoading();
        if (res.responseCode === 0) {
          this.data = res.responseBody;
        } else {
          showToast(res.responseMsg);
        }
      })
      .catch((e) => {
        console.log(e);
        showToast(e);
      })
  },
};
</script>

<style scoped lang="scss">
.detail {
  margin: 128px 36px 80px 36px;
}

.name {
  color: #333333;
  font-size: 54px;
}

.space {
  margin: 0 15px;
}

.jobAddress {
  font-weight: 500;
  color: #52647c;
  font-size: 36px;
  letter-spacing: 1px;
  margin-top: 24px;
}

.title {
  font-weight: 600;
  color: #212121;
  font-size: 42px;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
}

.desc {
  margin-top: 60px;
}

.introduce {
  font-weight: 400;
  color: #333333;
  line-height: 90px;
  font-size: 45px;
  margin-top: 24px;
  white-space: pre-wrap;
}

.ask {
  margin-top: 40px;
}

.divide {
  width: 6px;
  height: 40px;
  background: #2c68ff;
  display: inline-block;
  margin-right: 12px;
}
</style>
